module.exports = __webpack_public_path__ + "img/template-dne-market-default.5bab6514.jpg";